// extracted by mini-css-extract-plugin
module.exports = {"main":"articleLoading_main__2Hok1","loadingBox":"articleLoading_loadingBox__3LsIW","loading":"articleLoading_loading__2Tfkr"};